export function setNativeValue(element, value) {
    // https://github.com/facebook/react/issues/10135#issuecomment-314441175
    // this allows us to manually change an input element's value whilst also have
    // React track the change. This would be used for updating a input value before
    // dispatching an event programmatically.
    const valueSetter = Object.getOwnPropertyDescriptor(element, 'value').set;
    const prototype = Object.getPrototypeOf(element);
    const prototypeValueSetter = Object.getOwnPropertyDescriptor(
        prototype,
        'value',
    ).set;

    if (valueSetter && valueSetter !== prototypeValueSetter) {
        prototypeValueSetter.call(element, value);
    } else {
        valueSetter.call(element, value);
    }
}

export function toCurrency(value) {
    const formatter = new Intl.NumberFormat('en-AU', {
        style: 'currency',
        currency: 'AUD',
    });

    return formatter.format(value);
}

export function copyInputToClipboard(element) {
    element.select();
    element.setSelectionRange(0, 99999);
    document.execCommand('copy');
    window.getSelection().removeAllRanges();
    element.blur();
}

export default { setNativeValue, toCurrency };
